module.exports = __webpack_public_path__ + "static/media/boy-book.ab50716f.jpg";